<script>
    export let isActive = false;
    export let onClick = () => {};
    export let label;
    export let icon;

    export let withFixedHeight = false;
    export let withVariableWidth = false;

    export let variant = 'base';
</script>

<button
    class="service-item {isActive && 'service-item-active'} {withFixedHeight &&
        'service-item-fixed-height'} {withVariableWidth &&
        'service-item-variable-width'} {variant === 'dark' &&
        'service-item-dark'} {variant === 'dark' &&
        isActive &&
        'service-item-active-blue'}"
    on:click={onClick}
>
    {#if isActive}
        <div class="offer-option-check">
            {#if variant === 'dark'}
                <img
                    src="/assets/img/icons/check-option-blue.svg"
                    alt="móvil"
                />
            {:else}
                <img src="/assets/img/icons/check-option.svg" alt="móvil" />
            {/if}
        </div>
    {/if}
    {#if icon}
        <svg class="icon"><use xlink:href={icon}></use></svg>
    {/if}
    <p class="">{label}</p>
</button>
